__turbopack_context__.v({
  "navLinkWrapper": "MyCollections-module-scss-module__I6JRuW__navLinkWrapper",
  "rowDefault": "MyCollections-module-scss-module__I6JRuW__rowDefault",
  "rowIcon": "MyCollections-module-scss-module__I6JRuW__rowIcon",
  "rowMeta": "MyCollections-module-scss-module__I6JRuW__rowMeta",
  "sectionChevron": "MyCollections-module-scss-module__I6JRuW__sectionChevron",
  "sectionChevronCollapsed": "MyCollections-module-scss-module__I6JRuW__sectionChevronCollapsed",
  "sectionHeader": "MyCollections-module-scss-module__I6JRuW__sectionHeader",
});
